import * as React from "react";
import { jsx as _jsx } from "react/jsx-runtime";
const SvgNewsmode = (props) => /* @__PURE__ */ _jsx("svg", {
	width: 16,
	height: 16,
	viewBox: "0 0 16 16",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: /* @__PURE__ */ _jsx("g", {
		transform: "translate(1.33333 2)",
		children: /* @__PURE__ */ _jsx("path", {
			d: "M1.33333 12C0.966667 12 0.652778 11.8694 0.391667 11.6083C0.130556 11.3472 0 11.0333 0 10.6667V1.33333C0 0.966667 0.130556 0.652778 0.391667 0.391667C0.652778 0.130556 0.966667 0 1.33333 0H12C12.3667 0 12.6806 0.130556 12.9417 0.391667C13.2028 0.652778 13.3333 0.966667 13.3333 1.33333V10.6667C13.3333 11.0333 13.2028 11.3472 12.9417 11.6083C12.6806 11.8694 12.3667 12 12 12H1.33333ZM1.33333 10.6667H12V1.33333H1.33333V10.6667ZM2.66667 9.33333H10.6667V8H2.66667V9.33333ZM2.66667 6.66667H5.33333V2.66667H2.66667V6.66667ZM6.66667 6.66667H10.6667V5.33333H6.66667V6.66667ZM6.66667 4H10.6667V2.66667H6.66667V4Z",
			fill: "currentColor"
		})
	})
});
export default SvgNewsmode;
